<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 18 18"
	><path
		fill="currentColor"
		d="M9 1.688A7.312 7.312 0 1 0 16.313 9 7.32 7.32 0 0 0 9 1.688m0 13.5A6.187 6.187 0 1 1 15.188 9 6.195 6.195 0 0 1 9 15.188m-.562-5.626V5.626a.563.563 0 0 1 1.124 0v3.938a.563.563 0 1 1-1.124 0m1.406 2.532a.844.844 0 1 1-1.687 0 .844.844 0 0 1 1.687 0"
	/></svg
>
